$(function() {
	// @codekit-prepend 'js/functions.js'
	// @codekit-prepend 'js/pusher.js'
	// @codekit-prepend 'js/notifications.js'
	// @codekit-prepend 'js/file-uploader.js'
	// @codekit-prepend 'js/files-uploader.js'
	// @codekit-prepend 'js/dropdown.js'
	// @codekit-prepend 'js/slideout.js'
	// @codekit-prepend 'js/accounts.js'
	// @codekit-prepend 'js/settings.js'
    
    
    // @codekit-prepend 'js/parcels.js'
    // @codekit-prepend 'js/addresses.js'
    // @codekit-prepend 'js/from-addresses.js'
    // @codekit-prepend 'js/shipments.js'
    // @codekit-prepend 'js/slideouts/new-shipment.js'
});